import {EXAMPLE_EMAIL} from '../constants';

export const getEditorPermissionCheckboxText = (serviceEmail: string) =>
  `I have given editor permissions to <${serviceEmail ?? EXAMPLE_EMAIL}> for this folder`;
